import { c as _c } from "react/compiler-runtime";
import { PAGE_TEMPLATES_API } from 'modules/funnels/funnel/api/page-templates-api';
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header';
import PageTemplatePagination, { PageTemplateLimitType } from 'modules/funnels/funnel/components/page-template-selector/page-template-pagination';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { usePageTemplates } from 'modules/funnels/funnel/hooks/use-page-templates';
import { FunnelPageTemplateId } from 'modules/funnels/funnel/types/funnel-page-template-interface';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getPageTypeFromFunnelStepType } from 'modules/funnels/funnel/utils/get-page-type-from-funnel-step-type';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useEffect, useRef, useState } from 'react';
import { Loader } from 'shared/components/loader';
import { TemplateCard } from 'shared/components/template-card';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { useSelectPageTemplate } from '../../hooks/use-select-page-template';
interface PageTemplateSelectorProps {
  funnelStep: FunnelStepInterface | null;
  funnelId: FunnelId;
}
function PageTemplateSelector(t0) {
  const $ = _c(32);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    user
  } = useUser();
  const [limit, setLimit] = useState(9);
  const {
    pagination,
    setPagination
  } = usePagination(true);
  const {
    selectPageTemplate,
    isFetching
  } = useSelectPageTemplate();
  let t1;
  if ($[0] !== limit) {
    t1 = {
      limit,
      setLimit
    };
    $[0] = limit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const limiter = t1;
  let t2;
  if ($[2] !== pagination || $[3] !== setPagination) {
    t2 = {
      pagination,
      setPagination
    };
    $[2] = pagination;
    $[3] = setPagination;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const paginator = t2;
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const t3 = funnelStep?.type;
  let t4;
  if ($[5] !== t3) {
    t4 = getPageTypeFromFunnelStepType(t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== limit || $[8] !== pagination || $[9] !== t4) {
    t5 = {
      type: t4,
      limit,
      pagination
    };
    $[7] = limit;
    $[8] = pagination;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    pageTemplates
  } = usePageTemplates(t5);
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      api: PAGE_TEMPLATES_API
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const updateStepTemplatesData = useUpdateData(t6);
  const [selectedPageTemplate, setSelectedPageTemplate] = useState();
  const templatesContainerRef = useRef(null);
  let t7;
  if ($[12] !== funnelStep || $[13] !== mutateFunnelStepsList || $[14] !== selectPageTemplate) {
    t7 = async pageTemplateId => {
      ;
      try {
        if (funnelStep) {
          setSelectedPageTemplate(pageTemplateId);
          const response = await selectPageTemplate(funnelStep.id, pageTemplateId);
          await mutateFunnelStepsList(data => {
            if (data) {
              return data.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return response;
                }
                return dataFunnelStep;
              });
            }
          }, false);
          setSelectedPageTemplate(undefined);
        }
      } catch (t8) {
        setSelectedPageTemplate(undefined);
      }
    };
    $[12] = funnelStep;
    $[13] = mutateFunnelStepsList;
    $[14] = selectPageTemplate;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const onSelect = t7;
  let t8;
  if ($[16] !== pageTemplates || $[17] !== updateStepTemplatesData) {
    t8 = () => {
      const revalidateStepTemplates = async () => await updateStepTemplatesData(false, pageTemplates);
      if (pageTemplates) {
        revalidateStepTemplates();
      }
    };
    $[16] = pageTemplates;
    $[17] = updateStepTemplatesData;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = user?.dashboardLocale;
  let t10;
  if ($[19] !== t9) {
    t10 = [t9];
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  useEffect(t8, t10);
  const t11 = !!pageTemplates;
  let t12;
  if ($[21] !== funnelStep || $[22] !== isFetching || $[23] !== limiter || $[24] !== onSelect || $[25] !== pageTemplates || $[26] !== paginator || $[27] !== selectedPageTemplate) {
    t12 = !pageTemplates || !funnelStep ? <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div> : <div className="mb-10 flex flex-col gap-5 px-[15px] lg:px-[15px]"><MobileSettingsHeader type={FunnelStepSettingTabsEnum.stepConfiguration} /><div className="grid w-full grid-cols-1 justify-between gap-x-8 gap-y-14 xl:grid-cols-2 2xl:grid-cols-3" ref={templatesContainerRef}>{pageTemplates.items?.map(template => <TemplateCard key={template.id} onSelect={() => onSelect(template.id)} isActive={selectedPageTemplate === template.id} isFetching={isFetching} className="aspect-video h-full w-full" preview={{
          href: `/dashboard/page/template/${template.id}/show`,
          dataTestId: `preview-template-${template.id}`
        }} dataTestId={`select-template-${template.id}`}><img alt={template.previewImage.filename} src={template.previewImage.path} data-test-element={template.name} className="w-[-webkit-fill-available]" /></TemplateCard>)}</div><PageTemplatePagination data={pageTemplates} limiter={limiter} paginator={paginator} /></div>;
    $[21] = funnelStep;
    $[22] = isFetching;
    $[23] = limiter;
    $[24] = onSelect;
    $[25] = pageTemplates;
    $[26] = paginator;
    $[27] = selectedPageTemplate;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <div data-test-table-is-loaded={t11}>{t12}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}
export default PageTemplateSelector;